// 状态异常列表页

import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import { getCityList, stubLongAbnormalList } from "@/fetch/fetchApi";
import FormCore from "@/components/display/form/formCore";
import PropTypes from "prop-types";
import RefreshGrid from "@/utils/refreshGrid";
import "@/assets/stylus/oprationLog.styl";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { message } from "antd/lib/index";

@connect((state) => state)
class StateUnusualList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;
    this.state = {};
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载前方法
  componentWillMount() {
    this.setState({
      formConfig: this.initForm(),
    });
    this.initTable();
  }

  // 页面加载完成方法
  componentDidMount() {
    this.fetchApi({});
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整

    return `${day}天`;
  }

  // 加载form方法
  initForm() {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入设备编号",
          param: {
            name: "stubId",
            type: "string",
          },
          defaultValue: this.queryStubId,
          labelName: "设备编号:",
          required: false,
        },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: "请选择地区",
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区",
          className: "allshow",
          sourceApi: getCityList,
        },
        {
        type: "select",
        placeholder: "请选择", // '请选择设备状态',
        labelName: "运营类型", // '设备状态',
        param: {
          name: "operationMode",
          type: "string",
        },
        options: [
          {
            text: "全部",
            value: "",
          },
          {
            text: "非直营",
            value: "0",
          },
          {
            text: "直营",
            value: "1",
          }],
        required: false,
      },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "input",
              placeholder: "最小值(天)",
              inputType: "number",
              width: "95px",
              param: {
                name: "minNum",
                type: "string",
              },
              labelName: "异常天数",
              required: false,
              // validator: { // 自定义校验对象
              //     vtype: 'positiveInt', // 校验名称
              //     min_val: 1, // 可输入最小值
              //     max_val: 999 // 可输入最大值
              // },
            },
            {
              type: "input",
              placeholder: "最大值(天)",
              inputType: "number",
              width: "95px",
              param: {
                name: "maxNum",
                type: "string",
              },
              required: false,
              // validator: { // 自定义校验对象
              //     vtype: 'positiveInt', // 校验名称
              //     min_val: 1, // 可输入最小值
              //     max_val: 999 // 可输入最大值
              // },
            },
          ],
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: "查询",
              icon: "search",
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {},
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "stateUnusualTable",
    };

    return formConfig;
  }

  // 加载表格方法
  initTable() {
    // 表格初始化方法
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: "设备编号",
            key: "stubId",
            width: "13%",
            align: "left",
            colType: "textCol",
          },
          {
            name: "电站",
            key: "stubGroupName",
            align: "left",
            colType: "tipCol",
          },
          {
            name: "地区",
            key: "cityName",
            width: "13%",
            align: "left",
            colType: "textCol",
          },
          {
            name: "运营类型",
            key: "operationMode",
            colType: "textCol",
            align: "left",
            width: 200,
            render: (value) => {
              if (value.toString() === "1") {
                return "直营";
              } else if (value.toString() === "0") {
                return "非直营";
              } else {
                return "--";
              }
            },
          },
          {
            name: "状态",
            key: "stubStatus",
            width: "13%",
            align: "left",
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case "02":
                  return "故障";
                // break;
                case "05":
                  return "离线";
                // break;
                default:
                  return "--";
                // break;
              }
            },
          },
          {
            name: "异常开始时间",
            key: "createTime",
            width: "300px",
            align: "left",
            colType: "textCol",
          },
          {
            name: "异常时长",
            key: "errorDuration",
            align: "left",
            colType: "textCol",
            render: (value) => {
              return this.handleSecord(value);
            },
          },
        ],
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
          console.debug("change");
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        tableKey: "stateUnusualTable",
        dataApi: stubLongAbnormalList,
      },
    });
  }

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    const newParam = param;
    //

    if (param.minNum || param.minNum === 0) {
      if (Number(param.minNum).toString === "NaN" || param.minNum.includes(".")) {
        message.error("异常天数需为≥1的正整数或≤999的正整数！");
        return false;
      }
      if (param.minNum < 1 || param.minNum > 999) {
        message.error("异常天数需为≥1的正整数或≤999的正整数！");
        return false;
      }
    }
    if (param.maxNum || param.maxNum === 0) {
      if (Number(param.maxNum).toString === "NaN" || param.maxNum.includes(".")) {
        message.error("异常天数需为≥1的正整数或≤999的正整数！");
        return false;
      }
      if (param.maxNum < 1 || param.maxNum > 999) {
        message.error("异常天数需为≥1的正整数或≤999的正整数！");
        return false;
      }
    }
    if (param.minNum && param.maxNum) {
      // 字符串不能和字符串直接进行数字比较，比的是char,不会隐式转换为数字 需要显转
      if (Number(param.minNum) >= Number(param.maxNum)) {
        message.error("异常天数最大值必须大于最小值！");
        return false;
      }
    }
    newParam.operationProperty = "3";
    // 城市id格式化
    newParam.cityId =
      newParam.cityId === undefined
        ? ""
        : newParam.cityId
            .toString()
            .slice(
              newParam.cityId.toString().lastIndexOf(",") + 1,
              newParam.cityId.toString().length,
            );

    // 如果正常页面中的表单提交，请执行下面
    return RefreshGrid(this.context.store, "stateUnusualTable", newParam);
  }

  render() {
    const content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(StateUnusualList);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/stateUnusual/stateUnusualList.js